import { Api } from 'utils';

class ClientService {
	
	static get = async (params?: any) => Api.createResponse('client/users/get',params);
	static create = async (params?: any) => Api.createResponse('client/users/create',params);
	static update = async (params?: any) => Api.createResponse('client/users/update',params);
	static delete = async (params?: any) => Api.createResponse('client/users/delete',params);

}

export default ClientService;